import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import { cognitoConfig, apiEndpoints, awsRegion, isProduction } from './config/environment';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: cognitoConfig.userPoolId,
      userPoolClientId: cognitoConfig.userPoolClientId,
      identityPoolId: cognitoConfig.identityPoolId,
      loginWith: {
        username: true,
        email: true,
      },
    },
  },
  API: {
    REST: {
      ClientPortalAPI: {
        endpoint: apiEndpoints.clientPortal,
        region: awsRegion,
      },
      RiaAPI: {
        endpoint: apiEndpoints.ria,
        region: awsRegion,
      },
      ApexAPI: {
        endpoint: apiEndpoints.apex,
        region: awsRegion,
      },
      PlaidCashAPI: {
        endpoint: apiEndpoints.plaidCash,
        region: awsRegion,
      },
      IdentityAPI: {
        endpoint: apiEndpoints.identity,
        region: awsRegion,
      },
      FinancialPlanAPI: {
        endpoint: apiEndpoints.financialPlan,
        region: awsRegion,
      },
      FeatureFlagsAPI: {
        endpoint: apiEndpoints.featureFlags,
        region: awsRegion,
      },
      TaxAPI: {
        endpoint: isProduction ? 'https://tax.wavvest.com' : 'https://staging.tax.wavveststg.com',
        region: 'us-west-2',
      },
      // Insurance (Ladder) service. Auth is AWS IAM (SigV4) via the Cognito
      // Identity Pool auth role — the API Gateway uses an IAM authorizer — so
      // `region` is set for Amplify to SigV4-sign, same as the other services.
      InsuranceAPI: {
        endpoint: apiEndpoints.insurance,
        region: awsRegion,
      },
    },
  },
};

const isLocalClientPortalApiEndpoint =
  /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/i.test(apiEndpoints.clientPortal) ||
  apiEndpoints.clientPortal.includes('/__local_client_portal_api__');

Amplify.configure(awsConfig, {
  API: {
    REST: {
      headers: async ({ apiName }) => {
        const isPlaidCashApi = apiName === 'PlaidCashAPI';
        const isLocalClientPortalApi =
          apiName === 'ClientPortalAPI' && isLocalClientPortalApiEndpoint;
        if (!isPlaidCashApi && !isLocalClientPortalApi) {
          return {};
        }

        try {
          const { tokens } = await fetchAuthSession();
          if (isPlaidCashApi) {
            const idToken = tokens?.idToken?.toString();
            return idToken ? { 'X-Cognito-ID-Token': idToken } : {};
          }

          const token = tokens?.accessToken?.toString() || tokens?.idToken?.toString();

          if (token) {
            return {
              Authorization: token,
            };
          }
        } catch {
          console.warn('Failed to resolve API auth headers');
        }

        return {};
      },
    },
  },
});

export default awsConfig;
